<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Email-->
<div class="MainBorder TopMargin">
	<h3>Test Email</h3>

	<div class="Buttons">
		<button class="btn btn-primary" (click)="onSendEmail()">Send Email</button>
	</div>
</div>

<!--CAASS Notify-->
<div class="MainBorder TopMargin">
	<h3>CAASS Notify</h3>

	<!--Schools Table (W/Enable, Disable buttons)-->
	<div>
		<h4>Schools To Update:</h4>

		<caass-prefs-caass-notify-school-table> </caass-prefs-caass-notify-school-table>
	</div>
</div>

<!--Custom Preferences-->
<div class="MainBorder TopMargin">
	<h3>Add Preferences</h3>

	<!--Preference Info-->
	<div class="FormGrid TopMargin">
		<label>Category:</label>
		<input [(ngModel)]="Category" class="form-control" type="text" />

		<label>Key Name:</label>
		<input [(ngModel)]="KeyName" class="form-control" type="text" />

		<label>Key Value:</label>
		<input [(ngModel)]="KeyValue" class="form-control" type="text" />

		<!-- <label>Add to:</label>
        <div class="RadioGrid">
            <input name="SchoolOption" id="School" value="School" [(ngModel)]="SchoolOption" type="radio">
            <label for="School">School(s)</label>
        
            <input style="margin-left: 10px;" name="SchoolOption" id="District" value="District" [(ngModel)]="SchoolOption"  type="radio">
            <label for="District">District</label>
        </div> -->

		<!-- <label>Person ID:</label>
        <input class="form-control" type="text" placeholder="NULL">

        <label>Facility ID:</label>
        <input class="form-control" type="text" placeholder="NULL">

        <label>School ID:</label>
        <input class="form-control" type="text" placeholder="NULL">

        <label>ScanStation ID:</label>
        <input class="form-control" type="text" placeholder="NULL"> -->
	</div>

	<!--Schools-->
	<div *ngIf="SchoolOption == 'School'" class="TopMargin">
		<h4>Add to Schools:</h4>

		<div>
			<caass-prefs-school-table> </caass-prefs-school-table>
		</div>
	</div>

	<!--Buttons-->
	<div class="Buttons">
		<!-- <button class="btn btn-primary" (click)="onSearchPref()">Search For Preference</button> -->
		<button [disabled]="processing == true" class="btn btn-primary" (click)="onAddPref()">Add Preference</button>
		<button [disabled]="processing == true" *ngIf="SchoolOption == 'School'" class="btn btn-primary" (click)="onClear()">Clear Schools</button>
		<button [disabled]="processing == true" class="btn btn-primary" (click)="onClearForm()">Clear Form</button>
	</div>

	<div class="TopMargin">
		<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
			{{ errorMessage }}
		</div>
	</div>
</div>

<!--Debug-->
<div class="MainBorder TopMargin">
	<h3>Debug Info</h3>

	<div class="FormGrid TopMargin">
		<label>Base URL:</label>
		<label *ngIf="LoadingBaseURL == true">...Loading</label>
		<label *ngIf="LoadingBaseURL == false">{{ BaseURL }}</label>
	</div>
</div>
